import { defineFetchForNamespace } from '../../redux/fetch';

import { fetchFlashMessages } from '../service';
import { addClientFlashMessage } from './actions';
import { getClientFlashMessages } from './selectors';
import { reducer as clientFlashMessageReducer } from './reducers';
import { FlashMessage } from '@pegasus/ui-flashmessages/types/flashmessage';
import { combineReducers } from 'redux';

export const NAME = 'fetch';
export const NAMESPACE = 'flashmessages';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    FlashMessage[],
    void,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, () => fetchFlashMessages().then(response => response.results));

const getFlashMessagesReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
        view: clientFlashMessageReducer,
    }),
});

export {
    getFlashMessagesReducer,
    getIsInitial,
    getIsLoading,
    getData as getFlashMessages,
    fetchData as fetchFlashMessages,
    // custom getters / actions
    getClientFlashMessages,
    addClientFlashMessage,
};
